import { render, staticRenderFns } from "./OpensFactor.vue?vue&type=template&id=9a6abcd4&"
import script from "./OpensFactor.vue?vue&type=script&lang=js&"
export * from "./OpensFactor.vue?vue&type=script&lang=js&"
import style0 from "./OpensFactor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports